import { gql } from '@apollo/client';
export const DetailsFragment = gql`
  fragment Details on CaseDetailsOutput {
    name
    created_by
    created_date
  }
`;
/*
export const DetailsFragment = gql`
  fragment Details on CaseDetailsOutput {
    id
    name
    description
    created_by
    created_date
    org_id
  }
`;
*/
